function keyPress(e) {
    let className = '';
    if (e.altKey && e.key === 'q') {
        className = 'oa_button';
    } else if (e.altKey && e.key === 'r') {
        className = 'correct_button';
    } else if (e.altKey && e.key === 'm') {
        className = 'match_button';
    }

    const element = document.getElementsByClassName(className);
    if (element && element.length === 1) {
        window.open(element[0].href);
    }
}

document.addEventListener('keydown', keyPress);
